/* global hcaptcha */
import { v as bvVar } from 'bv';
import { locale } from '../i18n';
import BaseHCaptchaService from './base_hcaptcha_service';

const { siteKey } = bvVar('captchaSettings');

export default class HCaptchaCaptchaService extends BaseHCaptchaService {
  token = '';

  refresh = () => {
    try {
      if (this.widgetId) {
        hcaptcha.reset(this.widgetId);
        this.token = '';
        this.setChallengeCompleted(false);
      } else {
        this.widgetId = hcaptcha.render('hcaptcha', {
          sitekey: siteKey,
          hl: locale().substr(0, 2),
          callback: (token) => {
            this.token = token;
            this.setChallengeCompleted(true);
          },
          'expired-callback': () => {
            this.token = '';
            this.setChallengeCompleted(false);
          },
        });
      }
    } catch {
      // noop
    }
  };

  execute = () => Promise.resolve(this.token);

  destroy = () => {
    try {
      this.setChallengeCompleted(false);
      hcaptcha.reset(this.widgetId);
      this.widgetId = '';
      this.token = '';
    } catch {
      // noop
    }
  };

  setChallengeCompleted = (completed) => {
    window.reduxActionDispatchers.captcha.setHCaptchaCompleted(completed);
  };
}
